import React, { useEffect } from 'react';

const GameOfLife = () => {
  const Sketch = (p) => {
    let cols, rows;
    let board;
    const cellSize = 10;
    let font;
    let nameWritten = false;

    p.preload = () => {
      font = p.loadFont('PressStart2P-Regular.ttf');
    };

    p.setup = () => {
      p.createCanvas(p.windowWidth, p.windowHeight);
      cols = Math.floor(p.width / cellSize);
      rows = Math.floor(p.height / cellSize);
      board = new Array(cols).fill(null).map(() => new Array(rows).fill(false));

      // Start with all cells dead
      for (let i = 0; i < cols; i++) {
        for (let j = 0; j < rows; j++) {
          board[i][j] = false;
        }
      }

      // Write name in pixels
      p.textFont(font);
      p.textSize(128); // Increased font size for better visibility
      const name = "Devin";
      const nameWidth = p.textWidth(name);
      const startX = (p.width - nameWidth) / 2;
      const startY = p.height / 2;

      // Convert text to pixels
      let points = font.textToPoints(name, startX, startY, 128, { // Adjusted for new font size
        sampleFactor: 0.25, // Adjusted for better performance
        simplifyThreshold: 0
      });

      points.forEach(point => {
        const gridX = Math.floor(point.x / cellSize);
        const gridY = Math.floor(point.y / cellSize);
        if (gridX >= 0 && gridX < cols && gridY >= 0 && gridY < rows) {
          board[gridX][gridY] = true;
        }
      });

      nameWritten = true;
      p.frameRate(30); // Adjusted frame rate for smoother animation
    };

    p.draw = () => {
      if (!nameWritten) return;

      // Calculate elapsed time in seconds since the sketch started
      const elapsedTime = p.millis() / 1000;

      // For the first 10 seconds, set frame rate to 30
      if (elapsedTime <= 10) {
        p.frameRate(30);
      } else {
        // After 10 seconds, increase the frame rate more rapidly and reach a steady fast frame rate
        const timePastInitial = elapsedTime - 10;
        const additionalFrames = Math.min(timePastInitial * 10, 90); // Faster linear increase, capped at 90 fps
        p.frameRate(30 + additionalFrames);
      }

      p.background(0);
      for (let i = 0; i < cols; i++) {
        for (let j = 0; j < rows; j++) {
          const x = i * cellSize;
          const y = j * cellSize;
          if (board[i][j]) {
            p.fill(255);
            p.stroke(0);
            p.rect(x, y, cellSize - 1, cellSize - 1);
          }
        }
      }

      // Run the Game of Life simulation continuously
      if (p.frameCount % 10 === 0) { // Run simulation step every 10 frames
        board = computeNextGeneration(board);
      }
    };

    const computeNextGeneration = (oldBoard) => {
      let newBoard = new Array(cols).fill(null).map(() => new Array(rows).fill(false));

      for (let i = 0; i < cols; i++) {
        for (let j = 0; j < rows; j++) {
          let aliveNeighbors = 0;
          for (let x = -1; x <= 1; x++) {
            for (let y = -1; y <= 1; y++) {
              if (x === 0 && y === 0) continue;
              const neighborX = (i + x + cols) % cols;
              const neighborY = (j + y + rows) % rows;
              if (oldBoard[neighborX][neighborY]) aliveNeighbors++;
            }
          }

          if (oldBoard[i][j] && aliveNeighbors < 2) newBoard[i][j] = false;
          else if (oldBoard[i][j] && aliveNeighbors > 3) newBoard[i][j] = false;
          else if (!oldBoard[i][j] && aliveNeighbors === 3) newBoard[i][j] = true;
          else newBoard[i][j] = oldBoard[i][j];
        }
      }

      return newBoard;
    };

    p.mousePressed = () => {
      const gridX = Math.floor(p.mouseX / cellSize);
      const gridY = Math.floor(p.mouseY / cellSize);
      if (gridX >= 0 && gridX < cols && gridY >= 0 && gridY < rows) {
        board[gridX][gridY] = !board[gridX][gridY]; // Toggle the cell state
      }
    };

    p.mouseDragged = () => {
      const gridX = Math.floor(p.mouseX / cellSize);
      const gridY = Math.floor(p.mouseY / cellSize);
      if (gridX >= 0 && gridX < cols && gridY >= 0 && gridY < rows) {
        // Set the cell to alive and prevent default to allow continuous drawing
        board[gridX][gridY] = true;
        p.preventDefault();
      }
    };
  };

  useEffect(() => {
    new window.p5(Sketch);
  }, []);

  return <div id="game-of-life" />;
};

export default GameOfLife;
